// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css"; // Ensure you are using css-loader
import * as VueGoogleMaps from "vue2-google-maps";
import "./stylus/main.styl";

Vue.config.productionTip = false;

Vue.use(Vuetify, {
  iconfont: 'fa'
});
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAkPcyTpUCAT5oyOzsDTfe6IidaWzU1P7w",
    libraries: "places" // necessary for places input
  }
});

export const bus = new Vue();

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js